import { render, staticRenderFns } from "./TicketOrder.vue?vue&type=template&id=35a3b416&scoped=true&lang=pug"
import script from "./TicketOrder.vue?vue&type=script&lang=js"
export * from "./TicketOrder.vue?vue&type=script&lang=js"
import style0 from "./TicketOrder.vue?vue&type=style&index=0&id=35a3b416&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3b416",
  null
  
)

export default component.exports